import React, { Component } from 'react';
import './SessionSurvey.css';
import RatingComponent from '../../../../../Components/RatingComponent/RatingComponent';
import ShortAnswerQandAComponent from '../../../../../Components/ShortAnswerQandAComponent/ShortAnswerQandAComponent';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { QuestionType } from '../../../../../Utils/Constants';
import MultipleChoiceComponent from '../../../../../Components/MultipleChoiceComponent/MultipleChoiceComponent';
import SimpleSearchBox from '../../../../../Components/SearchBox/SimpleSearchBox';
import { showGenericSkeletonScreen } from '../../../../../SkeletonScreens/SkeletonScreen';
import { ENGAGEMENT_DETAILS, SURVEY_SEARCH } from '../../../../../Telemetry/Mixpanel/Constants/mixpanelConstants';
import EndOfPage from '../../../../../Components/EndOfPage/EndOfPage';
export class SessionSurvey extends Component {
  static propTypes = {
    reduced_session_surveys: PropTypes.object,
    isBig: PropTypes.bool
  };
  static contextTypes = {
    t: PropTypes.func
  };
  constructor() {
    super();
    this.state = {
      textSearch: ''
    };
  }
  render() {
    const { fetching } = this.props.reduced_session_surveys;
    return (
      <React.Fragment>
        <div className="sessionSurveyEngagement">{this.searchComponent()}</div>
        <div className="engagementModalContent">
          {fetching ? (
            showGenericSkeletonScreen()
          ) : (
            <React.Fragment>
              {this.surveyComponent()}
              <EndOfPage />
            </React.Fragment>
          )}
        </div>
      </React.Fragment>
    );
  }

  surveyComponent = () => {
    const { surveys } = this.props.reduced_session_surveys;
    const filteredSurveys = surveys.filter(this.filterByText);
    return filteredSurveys.map((surveyQuestion, index) =>
      this.getChart(surveyQuestion.questionType, surveyQuestion, index, surveys.length)
    );
  };

  filterByText = survey => {
    const { textSearch } = this.state;
    return (
      (survey && survey.question.toUpperCase().includes(textSearch.toUpperCase())) ||
      survey.responses.reduce((result, { text }) => {
        if (result) {
          return true;
        } else {
          return text.toUpperCase().includes(textSearch.toUpperCase());
        }
      }, false)
    );
  };

  searchComponent() {
    const { t } = this.context;
    return (
      <div className="sessionSurveySearchBox">
        <SimpleSearchBox
          placeHolder={t('engagement.searchSurveyQuestions')}
          onSearchInputChange={textSearch => this.setState({ textSearch })}
          mixpanelData={{ action: ENGAGEMENT_DETAILS, searchType: SURVEY_SEARCH }}
        />
      </div>
    );
  }

  getChart(chartType, question, index, totalQuestions) {
    const { isBig } = this.props;
    const extraData = {
      currentQuestionIndex: index + 1,
      totalQuestions
    };
    switch (chartType) {
      case QuestionType.MULTIPLE_CHOICE:
      case QuestionType.SINGLE_CHOICE:
        return (
          <MultipleChoiceComponent isBig={isBig} qAndAInfo={{ ...question, ...extraData }} key={question.question} />
        );
      case QuestionType.RATING:
        let initialValue = 0;
        let numerator = question.responses.reduce(function(accumulator, currentValue) {
          return accumulator + currentValue.numberOfResponses * currentValue.text;
        }, initialValue);

        let denominator = question.responses.reduce(function(accumulator, currentValue) {
          return accumulator + currentValue.numberOfResponses;
        }, initialValue);

        let avgRating = numerator / denominator;

        return (
          <RatingComponent
            isBig={isBig}
            qAndAInfo={{
              ...question,
              ...extraData,
              avgRating: avgRating
            }}
            key={question.question}
          />
        );
      case QuestionType.SHORT_ANSWER:
        return (
          <ShortAnswerQandAComponent isBig={isBig} qAndAInfo={{ ...question, ...extraData }} key={question.question} />
        );
      default:
        return null;
    }
  }
}
export default connect(state => ({
  reduced_session_surveys: state.reduced_session_surveys
}))(SessionSurvey);



// WEBPACK FOOTER //
// ./src/GoToWebinar/Sessions/SessionDetails/Engagement/EngagementModal/SessionSurvey.js